import script from "./RepaymentTypeTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./RepaymentTypeTooltip.vue?vue&type=script&setup=true&lang=ts"

import "./RepaymentTypeTooltip.vue?vue&type=style&index=0&id=3f68af52&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f68af52"]])

export default __exports__